import React from 'react';

export const MarkdownArea = React.lazy(() => import('./MarkdownArea'));
